<script setup lang="ts">
import { ref, watch } from 'vue';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import { useRouter } from 'vue-router';

const props = defineProps<{
  visible: boolean;
}>();

const emit = defineEmits(['update:visible']);

const router = useRouter();
const visible = ref(props.visible);
const isLoading = ref(false);

watch(
  () => props.visible,
  (val) => {
    visible.value = val;
  },
);

watch(visible, (val) => {
  emit('update:visible', val);
});

const selectScreener = (screenerType: string, view = 'portal') => {
  if (screenerType === 'ssis_colab') {
    isLoading.value = true;
    router.push({
      name: 'UniversalScreener',
      params: { type: 'ssis-colab' },
      query: { view },
    });
    visible.value = false;
    isLoading.value = false;
  }
};

const closeModal = () => {
  visible.value = false;
};
</script>

<template>
  <Dialog
    v-model:visible="visible"
    modal
    header="Select Screener"
    :closable="true"
    :draggable="false"
    :style="{ width: '450px' }"
    class="universal-screeners-modal"
  >
    <div class="screener-options">
      <div class="screener-option">
        <Button
          label="SSIS CoLab"
          class="p-button-outlined w-full"
          :loading="isLoading"
          @click="selectScreener('ssis_colab')"
        />
        <p class="text-sm text-color-secondary mt-2">Access SSIS CoLab screeners and assessments</p>
      </div>
    </div>

    <template #footer>
      <Button label="Cancel" class="p-button-text" @click="closeModal" />
    </template>
  </Dialog>
</template>

<style lang="scss" scoped>
.universal-screeners-modal {
  .screener-options {
    padding: 1rem 0;

    .screener-option {
      margin-bottom: 1.5rem;

      &:last-child {
        margin-bottom: 0;
      }

      p {
        margin: 0;
        padding: 0 0.5rem;
      }
    }
  }
}
</style>
